import { headers, parseJSON } from '../../apiUtils';
import { arrayIsNotEmpty, downloadFile } from '../../utils';

export function fetchTicketCountOverTimeStats(fromDate, toDate, timePeriodicity, selectedFilters) {
    let path = `/api/systemdashboard/ticket-count-by-time?fromDate=${fromDate}&toDate=${toDate}&timePeriodicity=${timePeriodicity}`;
    if (arrayIsNotEmpty(selectedFilters)) {
        const newArray = selectedFilters.map(obj => {
            return {
                domainValueId: obj.id,
                domainValueName: obj.value,
                domainId: obj.domainId
            };
        });
        const stringifySelectedFilters = JSON.stringify(newArray);
        path += `&selectedFilters=${stringifySelectedFilters}`;
    }
    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchTicketCountOverTimeStatsForUsers(fromDate, toDate, timePeriodicity, selectedFilters, userId) {
    let path = `/api/systemdashboard/ticket-count-by-time-for-team?fromDate=${fromDate}&toDate=${toDate}&timePeriodicity=${timePeriodicity}`;
    if (userId) {
        path += `&userId=${userId}`;
    }
    if (arrayIsNotEmpty(selectedFilters)) {
        const newArray = selectedFilters.map(obj => {
            return {
                domainValueId: obj.id,
                domainValueName: obj.value,
                domainId: obj.domainId
            };
        });

        const stringifySelectedFilters = JSON.stringify(newArray);
        path += `&selectedFilters=${stringifySelectedFilters}`;
    }
    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchTicketCountOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, selectedFilters) {
    let path = `/api/systemdashboard/ticket-count-by-time-by-breakdown?fromDate=${fromDate}&toDate=${toDate}&timePeriodicity=${timePeriodicity}`;
    if (arrayIsNotEmpty(selectedFilters)) {
        const newArray = selectedFilters.map(obj => {
            return {
                domainValueId: obj.id,
                domainValueName: obj.value,
                domainId: obj.domainId
            };
        });

        const stringifySelectedFilters = JSON.stringify(newArray);
        path += `&selectedFilters=${stringifySelectedFilters}`;
    }
    if (pageBreakdown) {
        path += `&breakdown=${pageBreakdown}`;
    }
    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchResponseOverTimeStats(fromDate, toDate, timePeriodicity, selectedFilters) {
    let path = `/api/systemdashboard/response-breakdown-by-time?fromDate=${fromDate}&toDate=${toDate}&timePeriodicity=${timePeriodicity}`;
    if (arrayIsNotEmpty(selectedFilters)) {
        const newArray = selectedFilters.map(obj => {
            return {
                domainValueId: obj.id,
                domainValueName: obj.value,
                domainId: obj.domainId
            };
        });

        const stringifySelectedFilters = JSON.stringify(newArray);
        path += `&selectedFilters=${stringifySelectedFilters}`;
    }
    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchResponseOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, selectedFilters) {
    let path = `/api/systemdashboard/response-breakdown-by-time?fromDate=${fromDate}&toDate=${toDate}&timePeriodicity=${timePeriodicity}`;
    if (arrayIsNotEmpty(selectedFilters)) {
        const newArray = selectedFilters.map(obj => {
            return {
                domainValueId: obj.id,
                domainValueName: obj.value,
                domainId: obj.domainId
            };
        });

        const stringifySelectedFilters = JSON.stringify(newArray);
        path += `&selectedFilters=${stringifySelectedFilters}`;
    }
    if (pageBreakdown) {
        path += `&breakdown=${pageBreakdown}`;
    }
    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchSystemDashboardReport(fromDate, toDate, timePeriodicity) {
    let path = `/api/systemdashboard/report?fromDate=${fromDate}&toDate=${toDate}&timePeriodicity=${timePeriodicity}`;

    return downloadFile(path);
}

export function fetchAgentReport(fromDate, toDate, timePeriodicity) {
    let path = `/api/systemdashboard/agents-report?fromDate=${fromDate}&toDate=${toDate}&timePeriodicity=${timePeriodicity}`;

    return downloadFile(path);
}

export function fetchAgentReportAccumulated(fromDate, toDate) {
    let path = `/api/systemdashboard/agents-report-accumulated?fromDate=${fromDate}&toDate=${toDate}`;

    return downloadFile(path);
}

/////////////////////////////////////

export function fetchOverallPerformanceProgressOverTimeStats(fromDate, toDate, reasonForContactId, channelTypeId, agentId, teamId) {
    let path = `/api/systemdashboard/overall-performance-progress-over-time-stats?fromDate=${fromDate}&toDate=${toDate}`;
    if (reasonForContactId) {
        path += `&reasonForContactId=${reasonForContactId}`;
    }
    if (channelTypeId) {
        path += `&channelTypeId=${channelTypeId}`;
    }
    if (agentId) {
        path += `&agentId=${agentId}`;
    }
    if (teamId) {
        path += `&teamId=${teamId}`;
    }

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchHandleTimeOverTimeStats(fromDate, toDate, reasonForContactId, channelTypeId, agentId, teamId) {
    let path = `/api/systemdashboard/handle-time-over-time-stats?fromDate=${fromDate}&toDate=${toDate}`;
    if (reasonForContactId) {
        path += `&reasonForContactId=${reasonForContactId}`;
    }
    if (channelTypeId) {
        path += `&channelTypeId=${channelTypeId}`;
    }
    if (agentId) {
        path += `&agentId=${agentId}`;
    }
    if (teamId) {
        path += `&teamId=${teamId}`;
    }

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchOutliers(fromDate, toDate) {
    const path = `/api/systemdashboard/outliers?fromDate=${fromDate}&toDate=${toDate}`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchAlerts() {
    const path = `/api/alertv3`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchRfcTrendsStats(fromDate, toDate, trendSurveyQuestion) {
    let path = `/api/systemdashboard/rfc-trends?fromDate=${fromDate}&toDate=${toDate}&surveyQuestion=${trendSurveyQuestion}`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function _makeAlertSeen(alertId) {
    const url = `/api/AlertV3/make-seen`;
    return fetch(url, {
        headers: headers(),
        body: JSON.stringify(alertId),
        method: 'POST'
    });
}